import React from 'react';
import { Handle, Position } from '@xyflow/react';

// Custom Node for large grouping boxes
export const GroupNode = ({ data }) => {
  return (
    <div 
      className={`arch-group-node ${data.className || ''}`}
      style={{ 
        width: data.width, 
        height: data.height,
      }}
    >
      {data.title && (
        <div className={`group-title ${data.titleClassName || ''}`}>
          {data.title}
        </div>
      )}
      {/* Hidden handles for grouping edges if needed */}
      <Handle type="target" position={Position.Top} style={{ visibility: 'hidden' }} />
      <Handle type="source" position={Position.Bottom} style={{ visibility: 'hidden' }} />
      <Handle type="source" position={Position.Right} id="right" style={{ visibility: 'hidden' }} />
      <Handle type="target" position={Position.Top} className="hidden-handle" id="top" />
      <Handle type="source" position={Position.Bottom} className="hidden-handle" id="bottom" />
      <Handle type="source" position={Position.Right} className="hidden-handle" id="right" />
      <Handle type="target" position={Position.Left} className="hidden-handle" id="left" />

      {data.handles && data.handles.map((h, i) => (
        <Handle key={`h-${i}`} type={h.type} position={h.position} id={h.id} style={{ ...h.style, opacity: 0 }} />
      ))}
    </div>
  );
};

// Custom Node for individual items/boxes
export const ItemNode = ({ data }) => {
  return (
    <div className={`arch-item-node ${data.className || ''}`} style={{ width: data.width, height: data.height }}>
      <Handle type="target" position={Position.Top} id="top" />
      <Handle type="source" position={Position.Bottom} id="bottom" />
      <Handle type="target" position={Position.Left} id="left" />
      <Handle type="source" position={Position.Right} id="right" />
      
      {data.handles && data.handles.map((h, i) => (
        <Handle key={`h-${i}`} type={h.type} position={h.position} id={h.id} style={h.style} />
      ))}

      {data.icon && <div className="node-icon">{data.icon}</div>}
      {data.icons && (
        <div className="node-icons">
          {data.icons.map((icon, i) => <span key={i}>{icon}</span>)}
        </div>
      )}
      <div className="node-label">{data.label}</div>
    </div>
  );
};

// Custom Node for the Database specific style (cylinder/stack shape)
export const DatabaseNode = ({ data }) => {
  return (
    <div className={`arch-db-node ${data.className || ''}`} style={{ width: data.width, height: data.height }}>
      <Handle type="target" position={Position.Top} id="top" />
      <Handle type="source" position={Position.Bottom} id="bottom" />
      <Handle type="target" position={Position.Left} id="left" />
      <Handle type="source" position={Position.Right} id="right" />
      <div className="db-top"></div>
      <div className="db-body">
        {data.label}
      </div>
    </div>
  );
};

export const nodeTypes = {
  groupNode: GroupNode,
  itemNode: ItemNode,
  databaseNode: DatabaseNode,
};
